import React from 'react';

import Main from '../containers/Main';

const Home = () => <Main />;

export default Home;
